export enum ExpirationType {
  None = 0,
  IntervalExpiry = 1,
}
